import { Modal } from "@material-ui/core";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import getStringsBasedLang from "../../strings/get_strings";
import { makeStyles } from "@material-ui/core/styles";
import { antiNameHandler } from "../../modules/anti_name_handler";
import moment from "moment-jalaali";
import { Button, Switch } from "antd";
import CustomPrimaryButton from "../../modules/custom_primary_button/custom_primary_button";
import { useNavigate } from "react-router-dom";
import { createData } from "../../api/http-service";
import UseErrorHandling from "../../hook/UseErrorHandling";

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    /*   width: 400, */
    backgroundColor: "#ffffff",
    border: 0,
    boxShadow: "0 10px 80px 2px rgba(77, 72, 103, 0.15)",
    padding: theme.spacing(2, 4, 3),
    left: "50%",
    top: "50%",
    outline: 0,
    transform: "translate(-50%, -50%)",
    borderRadius: "15px",
    [theme.breakpoints.down("xs")]: {
      width: 280,
      padding: 10,
    },
  },
  border: {
    border: "solid 1px #E0E0E0",
  },
  border_bottom: {
    borderBottom: "solid 1px #E0E0E0",
  },
}));

let promiseInfo = {};
const SelectAvModal = forwardRef((props, ref) => {
  const [show, setShow] = useState(false);
  const [antiList, setAntiList] = useState([]);
  const [selectedAvs, setSelectedAvs] = useState([]);
  const classes = useStyles();
  const lang = localStorage.getItem("lang");
  const handleErrorApi = UseErrorHandling();

  useEffect(() => {
    createData("avs/list")
      .then((avsListResult) => {
        if (!avsListResult?.success) {
          handleErrorApi(avsListResult);
          return;
        }
        let selected = [];
        let filteredAvs = avsListResult.data.filter((x) => x.version !== null);
        setAntiList(filteredAvs);
        filteredAvs.forEach((av) => {
          selected.push(av.name);
        });
        setSelectedAvs(selected);
      })
      .catch((error) => {
        if (error?.response) {
          handleErrorApi(error?.response.data);
        }
      });
    
  }, []);

  useImperativeHandle(ref, () => ({
    showAlert: async () => {
      return new Promise((resolve, reject) => {
        setShow(true);
        promiseInfo = {
          resolve,
          reject,
        };
      });
    },
  }));

  const countinueHandler = () => {
    promiseInfo.resolve(selectedAvs);
    setShow(false);
  };
  const rejectHandler = () => {
    setShow(false);
    promiseInfo.resolve("");
  };
  const onChange = (checked, anti_name) => {
    if (checked) {
      let data = selectedAvs.concat(anti_name);
      setSelectedAvs(data);
    } else {
      let array = [...selectedAvs];
      let index = array.indexOf(anti_name);
      if (index > -1) {
        array.splice(index, 1);
        setSelectedAvs(array);
      }
    }
  };
  const timeHandler = (version) => {
    if (lang === "en") return moment(version).format("YYYY/MM/DD");
    else return moment(version).format("jYYYY/jMM/jDD");
  };

  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setShow(false);
    }
  };
  const mapHandler = (data, index) => {
    return (
      <div
        key={index}
        className={`${classes.border_bottom} flex justify-between items-center px-5 py-2 xs:px-0`}
      >
        <div className="flex items-center">
          <div>
            <img
              className="w-6 h-6"
              src={require(`../../assets/icons/${
                data.name !== undefined &&
                antiNameHandler(data.name) !== "Unknown"
                  ? data.name
                  : "question"
              }.png`)}
              alt="Icon"
            />
          </div>
          <div className={`flex flex-col ${lang === "en" ? "ml-2" : "mr-2"}`}>
            <span className="primary_text_color text-sm englishIranSans">
              {antiNameHandler(data.name) === "Unknown"
                ? data.name
                : antiNameHandler(data.name)}
            </span>
            <span
              className={`text-xs secondry_text_color ${
                lang === "en" ? "englishIranSans" : ""
              }`}
            >
              <span>
                {getStringsBasedLang("general_lastVersioin")}:{" "}
                {data.version ? timeHandler(data.version) : "ندارد"}
              </span>
            </span>
          </div>
        </div>
        <div>
          <Switch
            defaultChecked={data.version ? true : false}
            disabled={data.version ? false : true}
            onChange={(checked) => onChange(checked, data.name)}
          />
        </div>
      </div>
    );
  };

  return (
    <React.Fragment>
      <Modal disableScrollLock={true} open={show} dis onClose={handleClose}>
        <div className={`${classes.paper} w-3/6 xs:w-5/6`}>
          <div className="flex flex-col items-center">
            <span className="primary_text_color font-bold text-lg">
              {getStringsBasedLang("selectAV_title")}
            </span>
            <span className="secondry_text_color text-sm">
              {getStringsBasedLang("selectAV_subTitle")}
            </span>
          </div>
          <div
            className={`${classes.border} p-5 rounded-lg mt-5 xs:h-60 sm:h-60 md:h-72 lg:max-h-96 xl:max-h-96 2xl:max-h-96 overflow-y-auto`}
          >
            {antiList.map(mapHandler)}
          </div>
          {selectedAvs.length > 0 && (
            <div className="flex items-center justify-center">
              <CustomPrimaryButton
                doClick={() => countinueHandler()}
                text={getStringsBasedLang("general_countinue")}
              />
              <div>
                <Button
                  onClick={() => rejectHandler()}
                  className={`rounded-3xl h-10 hover:-translate-y-1 ${
                    lang === "en" ? "ml-5 w-32" : "mr-5 w-24"
                  }`}
                  type=""
                >
                  {getStringsBasedLang("cancel")}
                </Button>
              </div>
            </div>
          )}
        </div>
      </Modal>
    </React.Fragment>
  );
});

export default SelectAvModal;
